import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=c939b92e&scoped=true"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=c939b92e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c939b92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c939b92e')) {
      api.createRecord('c939b92e', component.options)
    } else {
      api.reload('c939b92e', component.options)
    }
    module.hot.accept("./FlagIcon.vue?vue&type=template&id=c939b92e&scoped=true", function () {
      api.rerender('c939b92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FlagIcon.vue"
export default component.exports